module.exports = __webpack_public_path__ + "img/box6-26.1e84b1cd.png";